<template>
  <div class="CategoryFilter">
    <h3 class="CategoryFilter-title">
      <button 
        class="CategoryFilter-toggle" 
        type="button" 
        :aria-expanded="isOpen"
        @click="isOpen = !isOpen">
        <icon class="CategoryFilter-icon" name="filter-list"/>
        Filter by: <span>All</span>
      </button>
    </h3>
    <div class="CategoryFilter-items" id="categories" :hidden="!isOpen">
      <button 
        class="CategoryFilter-item" 
        :class="{ 'is-active': !selected }"
        name="category" 
        @click="$emit('change', null)">
        All
      </button>
      <button 
        v-for="(cat, i) in categories" 
        class="CategoryFilter-item" 
        :class="{ 'is-active': selected === cat.value }"
        :value="cat.value" 
        :key="i"
        @click="$emit('change', cat.value)">
          {{cat.label}}
      </button>
    </div>
  </div>
</template>

<script>
import Icon from '../UI/Icon.vue';

export default {
  inject: ["mq"],
  components: { Icon },

  data() {
    return {
      isOpen: this.mq.largePlus
    }
  },

  watch: {
    ['mq.largePlus']: function() {
      this.isOpen = this.mq.largePlus;
    },
  },

  props: {
    categories: Array,
    selected: String
  }
}
</script>